export default function initEspaceExposant(): void {
    const $espaceExposantContainer = document.querySelectorAll<HTMLElement>('.js-espace-exposant');
    $espaceExposantContainer.forEach($container => {
        new EspaceExposant($container);
    });
}

class EspaceExposant {
    $el: HTMLElement | null;
    $contactCommercialForm: HTMLElement | null | undefined;
    $badgesForm: HTMLElement | null | undefined;
    $prestationsForm: HTMLElement | null | undefined;
    $restaurationForm: HTMLElement | null | undefined;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$contactCommercialForm = $el?.querySelector('.js-contact-commercial-form');
        this.$badgesForm = $el?.querySelector('.js-badges-form');
        this.$prestationsForm = $el?.querySelector('.js-prestations-form');
        this.$restaurationForm = $el?.querySelector('.js-restauration-form');
        
        if (this.$el) {
            this.init();
        }
    }

    init(): void {
        // On affiche le bouton de confirmation sur le formulaire contact commercial s'il y a un changement
        this.$contactCommercialForm?.querySelectorAll('input').forEach((input) => {
            input.addEventListener('change', () => {
                this.$contactCommercialForm?.querySelector('button')?.classList.remove('hidden');
            });
        });

        // On affiche le bouton de confirmation sur le formulaire de commande de badges s'il y a un changement
        this.$badgesForm?.querySelectorAll('input').forEach((input) => {
            input.addEventListener('change', () => {
                this.$badgesForm?.querySelector('button')?.classList.remove('hidden');
            });
        });

        // On affiche le block de validation sur le formulaire correspondant s'il y a un changement
        this.$prestationsForm?.querySelectorAll('input').forEach((input) => {
            input.addEventListener('change', () => {
                this.$el?.querySelector('.js-validation-block')?.classList.remove('hidden');
            });
        });

        // On affiche le block de validation sur le formulaire correspondant s'il y a un changement
        this.$restaurationForm?.querySelectorAll('input').forEach((input) => {
            input.addEventListener('change', () => {
                this.$el?.querySelector('.js-validation-block')?.classList.remove('hidden');
            });
        });
        
    }
}
